module.exports = __webpack_public_path__ + "img/IhromBayu-nologo.4b1e7845.png";